// lib
import { useRef, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

// styles
import style from '@aytm/app/stats/page/question-views/components/questions-custom/styles/Component.module.scss'

const Sources = ({ source, data, entities, disabled, dispatch }) => {
  const sourceRef = useRef(null)

  const labelsOptions = useMemo(() => {
    const options = data.controls.labels.options[source]
    return options || []
  }, [source, data.controls.labels])
  const selectedLabels = useMemo(() => {
    const option = labelsOptions.find(_option =>
      _option.values.every((v, i) => {
        const index = entities.findIndex(item => item.pattern == data.options.entities[i].pattern)
        return entities[0 <= index ? index : i] != undefined ? v === entities[0 <= index ? index : i].text : ''
      })
    )

    return option != undefined && null !== option ? option.key : null
  }, [data.options.entities, entities, labelsOptions])

  const imagesOptions = useMemo(() => {
    const options = data.controls.images.options[source]
    return options != undefined ? [{ key: '*', text: 'No images' }].concat(options) : []
  }, [source, data.controls.images])
  const selectedImages = useMemo(() => {
    const option = imagesOptions.find(
      _option =>
        '*' !== _option.key &&
        _option.values.every((v, i) => {
          const index = entities.findIndex(item => item.pattern == data.options.entities[i].pattern)
          return entities[0 <= index ? index : i] != undefined ? v === entities[0 <= index ? index : i].image : null
        })
    )

    return option != undefined && null !== option ? option.key : null
  }, [data.options.entities, entities, imagesOptions])

  const onLabelsChange = useCallback(
    value => {
      const options = data.controls.labels.options[source]
      const option = options.find(_option => _option.key === value)

      dispatch({
        type: 'RESET',
        data: {
          entities: entities.map(item => {
            const index = data.options.entities.findIndex(entity => item.pattern == entity.pattern)
            return {
              ...item,
              text: option.values[index]
            }
          })
        }
      })
    },
    [source, data.controls.labels, data.options.entities, entities, dispatch]
  )
  const onImagesChange = useCallback(
    value => {
      if ('*' === value) {
        dispatch({
          type: 'RESET',
          data: {
            entities: entities.map(item => {
              return {
                ...item,
                image: null
              }
            })
          }
        })
      } else {
        const options = data.controls.images.options[source]
        const option = options.find(_option => _option.key === value)

        dispatch({
          type: 'RESET',
          data: {
            entities: entities.map(item => {
              const index = data.options.entities.findIndex(entity => item.pattern == entity.pattern)
              return {
                ...item,
                image: option.values[index]
              }
            })
          }
        })
      }
    },
    [source, data.controls.images, data.options.entities, entities, dispatch]
  )

  const itemTemplate = option => <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
  const valueTemplate = (option, _props) => (
    <span
      dangerouslySetInnerHTML={{ __html: option ? option.label || option.text : _props.placeholder || 'Select...' }}
    ></span>
  )

  return 0 < labelsOptions.length ? (
    <div className={style.row}>
      <div ref={sourceRef} className="p-composite-group p-fluid p-right p-col-6">
        <Dropdown
          className={`p-dropdown-rounded p-col-${0 < imagesOptions.length ? 6 : 12}`}
          placeholder="Labels..."
          value={selectedLabels}
          options={labelsOptions}
          optionValue="key"
          optionLabel="text"
          itemTemplate={itemTemplate}
          valueTemplate={valueTemplate}
          appendTo={sourceRef.current || 'self'}
          fixedDropdownDir="bottom"
          disabled={disabled}
          onChange={disabled ? null : event => onLabelsChange(event.value)}
        />
        {0 < imagesOptions.length ? (
          <Dropdown
            className="p-dropdown-rounded p-col-6"
            placeholder="Images..."
            value={selectedImages}
            options={imagesOptions}
            optionValue="key"
            optionLabel="text"
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
            appendTo={sourceRef.current || 'self'}
            fixedDropdownDir="bottom"
            disabled={disabled}
            onChange={disabled ? null : event => onImagesChange(event.value)}
          />
        ) : null}
      </div>
    </div>
  ) : null
}

Sources.propTypes = {
  source: PropTypes.string,
  data: PropTypes.object,
  entities: PropTypes.array,
  disabled: PropTypes.bool,
  dispatch: PropTypes.func
}

Sources.displayName = 'Sources'

export default Sources
